import clickElement from "./click-element";
import formInput from "./form-input";
import switchGroup from "./switch-group";
import clickCustomProcedureOption from "./click-custom-procedure-option";
import event from "../../lib/event";
import StepsRuntime from "../steps-runtime";
import {getBlockById} from "../blocks";
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';

/**
 *
 * @param name
 * @param [{name, type}] options  name为参数名或标签名；type取值0、1、2对应下面的三个选项的类型
 * @returns {Promise<Promise>}
 */
export default function createCustomProcedure({id, proccode, argumentnames, argumentids, tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    const codes = proccode.split(' ');
    const name = codes[0];
    if (mode) {
        if (!tips) {
            let index;
            let nameIndex = 0;
            let argName;
            tips = `创建一个名称为${name}的自定义积木，并添加：`;
            for (let i = 1; i < codes.length; ++i) {
                switch (codes[i]) {
                case '%s':
                    index = 0;
                    break;
                case '%b':
                    index = 1;
                    break;
                default:
                    index = 2;
                }
                if (index < 2) {
                    argName = argumentnames[nameIndex];
                    if (index === 0) {
                        tips +=  `文本参数（${argName}）`;
                    }else {
                        tips += `布尔参数（${argName}）`;
                    }
                    ++nameIndex;
                }else {
                    tips += `标签（${codes[i]}）`;
                }
            }
        }
        window.stepsRuntime.insertTips(_index, tips, true);
        if (mode === BATCH_TIPS_MODE) {
            return new Promise(resolve => {
                resolve();
            })
        }
    }

    return switchGroup({
            id: 'myBlocks',
            tips: '点击切换到『自制积木』积木组'
        }).then(()=>clickElement({
            element: "制作新的积木",
            tips: "点击这里制作新的积木，也就是创建一个『过程』"
        })).then(()=>formInput({
            element: "input.blocklyHtmlInput",
            value: name,
            tips: `这里输入自定义积木的名称：『${name}』`
        })).then(async ()=>{
            if (codes.length > 1) {
                let index;
                let nameIndex = 0;
                let argName;
                for (let i = 1; i < codes.length; ++i) {
                    switch (codes[i]) {
                        case '%s':
                            index = 0;
                            break;
                        case '%b':
                            index = 1;
                            break;
                        default:
                            index = 2;
                    }
                    if (index < 2) {
                        argName = argumentnames[nameIndex];
                        await clickCustomProcedureOption({
                            index
                        }).then(()=>formInput({
                            element: 'input.blocklyHtmlInput',
                            value: argName,
                            tips: `这里输入参数名『${argName}』`
                        }));
                        ++nameIndex;
                    }else {
                        await clickCustomProcedureOption({
                            index
                        }).then(()=>formInput({
                            element: 'input.blocklyHtmlInput',
                            value: codes[i],
                            tips: `这里输入标签『${codes[i]}』`
                        }));
                    }
                }
            }

        }).then(()=>{
            //监听创建事件，建立ID映射
            event.once('create', e=>{
                setTimeout(()=>{
                    const block = getBlockById(e.blockId);
                    if (block.opcode === "procedures_definition") {
                        stepsRuntime.setBlockId(id, e.blockId);
                        const prototypeBlock = getBlockById(block.inputs.custom_block.block);
                        //建立参数块的ID映射
                        let ids = JSON.parse(prototypeBlock.mutation.argumentids);
                        for (let i = 0; i < ids.length && i < argumentids.length; ++i) {
                            stepsRuntime.setBlockId(argumentids[i], prototypeBlock.inputs[ids[i]].block);
                        }
                    }
                }, 200);
            });
        })
        .then(()=>clickElement({
            element: 'button[class^="custom-procedures_ok-button"]',
            tips: '点击『确定』完成创建'
        })).then(()=>new Promise(resolve => {
            //等待自定义积木创建完成，并且建立好id映射
            setTimeout(()=>{resolve()}, 500);
        }));
}
